import './RouterMigrationModal.scss';
export class RouterMigrationModalController {
    static $inject = ['close', 'invalidRouters'];
    constructor(close, invalidRouters) {
        this.close = close;
        this.invalidRouters = invalidRouters;
    }
}
RouterMigrationModalController.$inject = ['close', 'invalidRouters'];
